window.addEventListener("load", (event) => {

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    var cur_width = $(window).width();

    $(window).resize(function () {
        if ($(window).width() <= 1366 && cur_width > 1366) {
            location.reload();
        } else if ($(window).width() > 1366 && cur_width <= 1366) {
            location.reload();
        }
    });

    window.addEventListener("orientationchange", (event) => {
        location.reload();
    });

    if (cur_width < 1366) {
        const mobileBtnOpen = document.querySelector('.js-open-menu');
        const mobileBtnClose = document.querySelector('.js-mobile-close');

        const header = document.querySelector('header.header');
        const isHtml = document.querySelector('html');

        mobileBtnOpen.addEventListener('click', (e) => {
            e.preventDefault();
            header.classList.add('isOpen');
            isHtml.classList.add('disabled');
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });



        mobileBtnClose.addEventListener('click', (e) => {
            e.preventDefault();
            header.classList.remove('isOpen');
            isHtml.classList.remove('disabled');
        });

        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 500);
            header.classList.remove('isOpen');
            isHtml.classList.remove('disabled');
        });

    }


    $('.js-popup').magnificPopup({
        disableOn: 0,
        type: 'ajax',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: true
    });

    const canvas = document.querySelectorAll('.js-canvas');

    canvas.forEach((el) => {
        if (el.classList.contains('canvas--introduction') || el.classList.contains('canvas--mind15') || el.classList.contains('canvas--footer')) {
            var granimInstance = new Granim({
                element: el,
                name: 'basic-gradient',
                direction: 'left-right',
                opacity: [1, 1],
                isPausedWhenNotInView: true,
                states: {
                    "default-state": {
                        gradients: [
                            ['#5B57EE', '#6869F4'],
                            ['#965DE9', '#6358EE'],
                            ['#21D4FD', '#B721FF']
                        ],
                        transitionSpeed: 2500,
                    }
                }
            });
        }
        if (el.classList.contains('canvas--awards')) {
            var granimInstance = new Granim({
                element: el,
                name: 'basic-gradient',
                direction: 'top-bottom',
                opacity: [1, 1],
                isPausedWhenNotInView: false,
                states: {
                    "default-state": {
                        gradients: [
                        
                            ['#ff9966', '#ff5e62'],
                            ['#DD6C82', '#FE5763'],
                            ['#EB6475', '#f05053']
                        ],
                        transitionSpeed: 2000,
                    }
                }
            });
        }
        if (el.classList.contains('canvas--team')) {
            var granimInstance = new Granim({
                element: el,
                name: 'basic-gradient',
                direction: 'left-right',
                opacity: [1, 1],
                isPausedWhenNotInView: true,
                states: {
                    "default-state": {
                        gradients: [
                            ['#0094FC', '#0CC0E0'],
                            ['#82AEFF', '#A38EFF'],
                            ['#00FFEF', '#8773F5']
                        ],
                        transitionSpeed: 2500,
                    }
                }
            });
        }
    });


    if (cur_width >= 1366) {

        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollLeft: $($.attr(this, 'href')).offset().left
            }, 500);
        });

        const cursors = document.querySelectorAll('.js-cursor');

        cursors.forEach((el) => {
            var parallaxInstance = new Parallax(el);
        });


        const scrollContainer = document.querySelector("body");

        // (function() {
        //     function scrollHorizontally(e) {
        //         e = window.event || e;
        //         var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
        //         document.documentElement.scrollLeft -= (delta*40); // Multiplied by 40
        //         document.body.scrollLeft -= (delta*40); // Multiplied by 40
        //         e.preventDefault();
        //     }
        //     if (window.addEventListener) {
        //         // IE9, Chrome, Safari, Opera
        //         window.addEventListener("mousewheel", scrollHorizontally, false);
        //         // Firefox
        //         window.addEventListener("DOMMouseScroll", scrollHorizontally, false);
        //     } else {
        //         // IE 6/7/8
        //         window.attachEvent("onmousewheel", scrollHorizontally);
        //     }
        //     })();



        function detectTrackPad(e) {
            var isTrackpad = false;
            console.log('ioe')
            if (e.wheelDeltaY) {
                if (e.wheelDeltaY === (e.deltaY * -3)) {
                    isTrackpad = true;
                }
            } else if (e.deltaMode === 0) {
                isTrackpad = true;
            }


            setTimeout(() => {
                console.log("set device", !isTrackpad);
                document.removeEventListener("mousewheel", detectTrackPad);
                document.removeEventListener("DOMMouseScroll", detectTrackPad);

                setTimeout(() => {
                    if (isTrackpad === false) {
                        $(document).ready(function () {
                            jQuery.scrollSpeed = function (step, speed, easing) {

                                var $document = $(document),
                                    $window = $(window),
                                    $body = $('html, body'),
                                    option = easing || 'default',
                                    root = 0,
                                    scroll = false,
                                    scrollY,
                                    scrollX,
                                    view;

                                if (window.navigator.msPointerEnabled)

                                    return false;

                                $window.on('mousewheel DOMMouseScroll', function (e) {

                                    var deltaY = e.originalEvent.wheelDeltaY,
                                        detail = e.originalEvent.detail;
                                    scrollY = $document.height() > $window.height();
                                    scrollX = $document.width() > $window.width();
                                    scroll = true;

                                    if (scrollY) {

                                        view = $window.height();

                                        if (deltaY < 0 || detail > 0)

                                            root = (root + view) >= $document.height() ? root : root += step;

                                        if (deltaY > 0 || detail < 0)

                                            root = root <= 0 ? 0 : root -= step;

                                        $body.stop().animate({

                                            scrollTop: root

                                        }, speed, option, function () {

                                            scroll = false;

                                        });
                                    }

                                    if (scrollX) {

                                        view = $window.width();

                                        if (deltaY < 0 || detail > 0)

                                            root = (root + view) >= $document.width() ? root : root += step;

                                        if (deltaY > 0 || detail < 0)

                                            root = root <= 0 ? 0 : root -= step;

                                        $body.stop().animate({

                                            scrollLeft: root

                                        }, speed, option, function () {

                                            scroll = false;

                                        });
                                    }

                                    return false;

                                }).on('scroll', function () {

                                    if (scrollY && !scroll) root = $window.scrollTop();
                                    if (scrollX && !scroll) root = $window.scrollLeft();

                                }).on('resize', function () {

                                    if (scrollY && !scroll) view = $window.height();
                                    if (scrollX && !scroll) view = $window.width();

                                });
                            };

                            jQuery.easing.default = function (x, t, b, c, d) {

                                return -c * ((t = t / d - 1) * t * t * t - 1) + b;
                            };


                            jQuery.scrollSpeed(100, 600);
                        });
                        console.log('isMouse', !isTrackpad)
                    }
                }, 100);
            }, 100);
        }

        document.addEventListener("mousewheel", detectTrackPad, false);

        document.addEventListener("DOMMouseScroll", detectTrackPad, false);










        // Stealed from: https://stackoverflow.com/questions/10744645/detect-touchpad-vs-mouse-in-javascript/31191250#31191250

        // let oldTime = 0;
        // let newTime = 0;
        // let isTrackPad;
        // let eventCount = 0;
        // let eventCountStart;

        // // const updateText = message => (text.textContent = message);

        // const resetDetection = () => {
        //     oldTime = 0;
        //     newTime = 0;
        //     isTrackPad = undefined;
        //     eventCount = 0;
        //     eventCountStart = undefined;
        //     // updateText("Scroll here");
        // };

        // const detectTrackpad = evt => {
        //     let isTrackPadDefined = isTrackPad || typeof isTrackPad !== "undefined";

        //     if (isTrackPadDefined) return;

        //     if (eventCount === 0) {
        //         eventCountStart = performance.now();
        //     }

        //     eventCount++;

        //     if (performance.now() - eventCountStart > 66) {
        //         if (eventCount > 5) {
        //             isTrackPad = true;
        //             document.removeEventListener("wheel", detectTrackpad);

        //             console.log('isTrackPad');
        //         } else {
        //             isTrackPad = false;
        //             $(document).ready(function () {
        //                 jQuery.scrollSpeed = function (step, speed, easing) {

        //                     var $document = $(document),
        //                         $window = $(window),
        //                         $body = $('html, body'),
        //                         option = easing || 'default',
        //                         root = 0,
        //                         scroll = false,
        //                         scrollY,
        //                         scrollX,
        //                         view;

        //                     if (window.navigator.msPointerEnabled)

        //                         return false;

        //                     $window.on('mousewheel DOMMouseScroll', function (e) {

        //                         var deltaY = e.originalEvent.wheelDeltaY,
        //                             detail = e.originalEvent.detail;
        //                         scrollY = $document.height() > $window.height();
        //                         scrollX = $document.width() > $window.width();
        //                         scroll = true;

        //                         if (scrollY) {

        //                             view = $window.height();

        //                             if (deltaY < 0 || detail > 0)

        //                                 root = (root + view) >= $document.height() ? root : root += step;

        //                             if (deltaY > 0 || detail < 0)

        //                                 root = root <= 0 ? 0 : root -= step;

        //                             $body.stop().animate({

        //                                 scrollTop: root

        //                             }, speed, option, function () {

        //                                 scroll = false;

        //                             });
        //                         }

        //                         if (scrollX) {

        //                             view = $window.width();

        //                             if (deltaY < 0 || detail > 0)

        //                                 root = (root + view) >= $document.width() ? root : root += step;

        //                             if (deltaY > 0 || detail < 0)

        //                                 root = root <= 0 ? 0 : root -= step;

        //                             $body.stop().animate({

        //                                 scrollLeft: root

        //                             }, speed, option, function () {

        //                                 scroll = false;

        //                             });
        //                         }

        //                         return false;

        //                     }).on('scroll', function () {

        //                         if (scrollY && !scroll) root = $window.scrollTop();
        //                         if (scrollX && !scroll) root = $window.scrollLeft();

        //                     }).on('resize', function () {

        //                         if (scrollY && !scroll) view = $window.height();
        //                         if (scrollX && !scroll) view = $window.width();

        //                     });
        //                 };

        //                 jQuery.easing.default = function (x, t, b, c, d) {

        //                     return -c * ((t = t / d - 1) * t * t * t - 1) + b;
        //                 };


        //                 jQuery.scrollSpeed(100, 600);
        //             });
        //             console.log('isTrackMouse');
        //             document.removeEventListener("wheel", detectTrackpad);
        //         }
        //         isTrackPadDefined = true;
        //         setTimeout(resetDetection, 2000);
        //     }
        // };

        // document.addEventListener("wheel", detectTrackpad);



        (function () {

            const items = document.querySelectorAll('.js-parallax-elem');

            items.forEach((item, i) => {
                // init controller
                const controller = new ScrollMagic.Controller({
                    vertical: false
                });

                // build tween
                const tween = TweenMax.to(item, 0.5, {
                    x: '-100vh'
                });

                // build scene and set duration to window height
                const scene = new ScrollMagic.Scene({
                        triggerElement: $('section.works')[0],
                        duration: $(window).height() / 3 * item.getAttribute('data-speed')
                    })
                    .setTween(tween)
                    // .addIndicators()
                    .addTo(controller);
            });
        })();

        (function () {

            const item = document.querySelector('.js-parallax-rabbit');
            // init controller
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            // build tween
            const tween = TweenMax.to(item, 0.5, {
                x: '-60vh',
                y: '65vh',
            });

            // build scene and set duration to window height
            const scene = new ScrollMagic.Scene({
                    triggerElement: $('.introduction .foot .motion')[0],
                    duration: $(window).height() / 3 * item.getAttribute('data-speed')
                })
                .setTween(tween)
                // .addIndicators()
                .addTo(controller);

        })();
        (function () {

            const item = document.querySelector('.js-works-tree');
            // init controller
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            // build tween
            const tween = TweenMax.to(item, 1, {
                x: '-60vh',
            });

            // build scene and set duration to window height
            const scene = new ScrollMagic.Scene({
                    triggerElement: $('.works .wrap:nth-child(2)')[0],
                    duration: $(window).height() / 3 * item.getAttribute('data-speed')
                })
                .setTween(tween)
                // .addIndicators()
                .addTo(controller);

        })();

        (function () {

            const item = document.querySelector('.js-directions-tree');
            // init controller
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            // build tween
            const tween = TweenMax.to(item, 1, {
                x: '-70vh',
            });

            // build scene and set duration to window height
            const scene = new ScrollMagic.Scene({
                    triggerElement: $('.awards .rating .item:nth-child(1)')[0],
                    duration: $(window).height() / 3 * item.getAttribute('data-speed')
                })
                .setTween(tween)
                // .addIndicators()
                .addTo(controller);

        })();

        (function () {

            const item = document.querySelector('.js-tigar');
            // init controller
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            // build tween
            const tween = TweenMax.to(item, 1, {
                x: '-70vh',
            });

            // build scene and set duration to window height
            const scene = new ScrollMagic.Scene({
                    triggerElement: $('.mind15 .wrapper .head a')[0],
                    duration: $(window).height() / 3 * item.getAttribute('data-speed')
                })
                .setTween(tween)
                // .addIndicators()
                .addTo(controller);

        })();


        (function () {
            const items = document.querySelectorAll('.js-directions-parallax');
            items.forEach((item, i) => {
                // init controller
                const controller = new ScrollMagic.Controller({
                    vertical: false
                });

                // build tween
                const tween = TweenMax.to(item, 0.5, {
                    x: '-100vh'
                });

                // build scene and set duration to window height
                const scene = new ScrollMagic.Scene({
                        triggerElement: $('section.directions')[0],
                        duration: $(window).height() / 3 * item.getAttribute('data-speed')
                    })
                    .setTween(tween)
                    // .addIndicators()
                    .addTo(controller);
            });
        })();

        (function () {
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            var scene = new ScrollMagic.Scene({
                    triggerElement: ".introduction",
                    duration: $('.introduction').width()
                })
                // animate color and top border in relation to scroll position
                .setTween(".introduction-tab", 1, {
                    width: '100%'
                }) // the tween durtion can be omitted and defaults to 1
                // .addIndicators({
                //     name: `2 (duration: ${$('.introduction').width()})`
                // }) 
                .addTo(controller);
        })();

        (function () {
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            var scene = new ScrollMagic.Scene({
                    triggerElement: ".works",
                    duration: $('.works').width()
                })
                // animate color and top border in relation to scroll position
                .setTween(".works-tab", 1, {
                    width: '100%'
                }) // the tween durtion can be omitted and defaults to 1
                // .addIndicators({
                //     name: `2 (duration: ${$('.works').width()})`
                // }) 
                .addTo(controller);
        })();

        (function () {
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            var scene = new ScrollMagic.Scene({
                    triggerElement: ".works",
                    duration: $('.works').width()
                })
                // animate color and top border in relation to scroll position
                .setTween(".header a", 1, {
                    color: "#EB6475"
                }) // the tween durtion can be omitted and defaults to 1
                // .addIndicators({
                //     name: `2 (duration: ${$('.works').width()})`
                // }) 
                .addTo(controller);
        })();

        (function () {
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            var scene = new ScrollMagic.Scene({
                    triggerElement: ".awards",
                    duration: $('.awards').width()
                })
                // animate color and top border in relation to scroll position
                .setTween(".awards-tab", 1, {
                    width: '100%'
                }) // the tween durtion can be omitted and defaults to 1
                // .addIndicators({
                //     name: `2 (duration: ${$('.awards').width()})`
                // }) 
                .addTo(controller);
        })();

        (function () {
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            var scene = new ScrollMagic.Scene({
                    triggerElement: ".directions",
                    duration: $('.directions').width()
                })
                // animate color and top border in relation to scroll position
                .setTween(".header a", 1, {
                    color: "#04A0F5"
                }) // the tween durtion can be omitted and defaults to 1
                // .addIndicators({
                //     name: `2 (duration: ${$('.directions').width()})`
                // }) 
                .addTo(controller);
        })();

        (function () {
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            var scene = new ScrollMagic.Scene({
                    triggerElement: ".knowledge",
                    duration: $('.knowledge').width()
                })
                // animate color and top border in relation to scroll position
                .setTween(".header a", 1, {
                    color: "#6463F2"
                }) // the tween durtion can be omitted and defaults to 1
                // .addIndicators({
                //     name: `2 (duration: ${$('.knowledge').width()})`
                // }) 
                .addTo(controller);
        })();

        (function () {
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            var scene = new ScrollMagic.Scene({
                    triggerElement: ".directions",
                    duration: $('.directions').width()
                })
                // animate color and top border in relation to scroll position
                .setTween(".directions-tab", 1, {
                    width: '100%'
                }) // the tween durtion can be omitted and defaults to 1
                // .addIndicators({
                //     name: `2 (duration: ${$('.directions').width()})`
                // }) 
                .addTo(controller);
        })();

        (function () {
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            var scene = new ScrollMagic.Scene({
                    triggerElement: ".mind15",
                    duration: $('.mind15').width()
                })
                // animate color and top border in relation to scroll position
                .setTween(".mind15-tab", 1, {
                    width: '100%'
                }) // the tween durtion can be omitted and defaults to 1
                // .addIndicators({
                //     name: `2 (duration: ${$('.mind15').width()})`
                // }) 
                .addTo(controller);
        })();

        (function () {
            const controller = new ScrollMagic.Controller({
                vertical: false
            });

            var scene = new ScrollMagic.Scene({
                    triggerElement: ".wda",
                    duration: $('.wda').width()
                })
                // animate color and top border in relation to scroll position
                .setTween(".wda-tab", 1, {
                    width: '100%'
                }) // the tween durtion can be omitted and defaults to 1
                // .addIndicators({
                //     name: `2 (duration: ${$('.wda').width()})`
                // }) 
                .addTo(controller);
        })();
    }
});